<template>
  <div class="container-fluid">
    <div class="swiper-container-wrapper swiper-container-wrapper--timeline">

      <swiper class="swiper-pagination-custom py-3" v-bind="swiperNavigationOptions" :modules="modules">
        <swiper-slide v-for="item in sliderItems" class=" swiper-pagination-switch">
          <div class="switch-title">
            <p> {{ item.navigationTitle }}</p>
          </div>
        </swiper-slide>
      </swiper>
      <div class="swiper-pagination swiper-pagination-progressbar swiper-pagination-horizontal"></div>

      <div class="container-fluid">
        <swiper @slideChange="onSlideChange" :navigation="true" v-bind="swiperMainOptions" :modules="modules"
                class="mySwiper"
                effect="fade">

          <swiper-slide v-for="item in sliderItems">
            <div class="col-12">
              <div class="row align-items-center">
                <div class="col-lg-6">
                  <img
                      class="object-cover w-100"
                      :src="item.image"
                      :alt="item.alt"
                  />
                </div>
                <div class="col-lg-6 my-3">
                  {{ item.text }}
                </div>
              </div>
            </div>
          </swiper-slide>

        </swiper>
      </div>


    </div>
  </div>
</template>
<script>
// Import Swiper Vue.js components
import {Swiper, SwiperSlide} from "swiper/vue";
import {EffectFade} from 'swiper';
// Import Swiper styles
import "swiper/css";

import "swiper/css/navigation";
import 'swiper/css/effect-fade';

// import required modules
import {Navigation, Autoplay} from "swiper";


import $ from 'jquery'

export default {
  components: {
    Swiper,
    SwiperSlide,
  },
  setup() {
    return {
      modules: [Navigation, Autoplay, EffectFade],
    };
  },
  props: {
    autoPlay: {
      type: Boolean,
      default: false,
    },
    autoPlayDuration: {
      default: 1000,
    },
    sliderItems: {
      default: [
        {
          text: "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Accusamus ad asperiores, aut debitis ",
          image: "https://picsum.photos/1280/721",
          alt: "mixitweb",
          navigationTitle: '1920'
        }
      ],
      optionType: 'static-form',
      formOptions: {
        sample: {
          text: {
            value: "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Accusamus ad asperiores, aut debitis ",
            valueType: String
          },
          image: {
            value: "https://picsum.photos/1280/721",
            valueType: String
          },
          alt: {
            value: "mixitweb",
            valueType: String
          },
          navigationTitle: {
            value: '1920',
            valueType: Number
          }
        },
      },
    },
    swiperPerViewSM: {
      type: Number,
      default: 2,
    },
    swiperPerViewMD: {
      type: Number,
      default: 3,
    },
    swiperPerViewLG: {
      type: Number,
      default: 4,
    },
  },
  data() {
    return {
      $,
      swiperMainOptions: {
        pagination: {
          el: '.swiper-pagination',
          clickable: true,
          dynamicBullets: true
        },
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
      },
      swiperNavigationOptions: {
        breakpoints: {
          300: {
            slidesPerView: 2,
            spaceBetween: 2,
          },
          400: {
            slidesPerView: 2,
            spaceBetween: 2,
          },
          430: {
            slidesPerView: 2,
            spaceBetween: 2,
          },
          490: {
            slidesPerView: 2,
            spaceBetween: 10,
          },
          520: {
            slidesPerView: 2,
            spaceBetween: 10,
          },
          768: {
            slidesPerView: 2,
            spaceBetween: 10,
          },
          980: {
            slidesPerView: 2,
            spaceBetween: 10,
          },
          1200: {
            slidesPerView: 3,
            spaceBetween: 10,
          },
        },
      },
    };
  },
  methods: {
    onSlideChange(swiper) {

      $(".swiper-pagination-custom .swiper-pagination-switch").removeClass("active");
      $(".swiper-pagination-custom .swiper-pagination-switch").eq(0).addClass("active");
      $(".swiper-pagination-custom .swiper-pagination-switch").removeClass("active");
      $(".swiper-pagination-custom .swiper-pagination-switch").eq(swiper.realIndex).addClass("active");


      $(".swiper-pagination-custom .swiper-pagination-switch").click(function () {
        swiper.slideTo($(this).index());
        $(".swiper-pagination-custom .swiper-pagination-switch").removeClass("active");
        $(this).addClass("active");
      });

    }
  },
  beforeMount() {
    if (this.autoPlay) {
      this.swiperMainOptions['autoplay'] = {
        delay: this.autoPlayDuration,
        disableOnInteraction: false,
      }
    }

    this.swiperNavigationOptions.breakpoints["300"].slidesPerView = this.swiperPerViewSM
    this.swiperNavigationOptions.breakpoints["400"].slidesPerView = this.swiperPerViewSM
    this.swiperNavigationOptions.breakpoints["430"].slidesPerView = this.swiperPerViewSM
    this.swiperNavigationOptions.breakpoints["490"].slidesPerView = this.swiperPerViewSM

    this.swiperNavigationOptions.breakpoints["520"].slidesPerView = this.swiperPerViewMD
    this.swiperNavigationOptions.breakpoints["768"].slidesPerView = this.swiperPerViewMD

    this.swiperNavigationOptions.breakpoints["980"].slidesPerView = this.swiperPerViewLG
    this.swiperNavigationOptions.breakpoints["1200"].slidesPerView = this.swiperPerViewLG

  }
};
</script>
<style scoped>

.swiper-container-wrapper--timeline .swiper-slide {
  display: flex;
  background: #fff;
//min-height: 300px; align-items: center; justify-content: center; border-radius: 10px;
}

.swiper-container-wrapper--timeline .swiper-slide .container {
  padding: 0;
  width: 100%;
}

.swiper-container-wrapper--timeline .swiper-slide .title {
  font-size: 18px;
  opacity: 0;
  transition: 0.5s ease 0.5s;
}

.swiper-container-wrapper--timeline .swiper-slide-active .title {
  opacity: 1;
}

.swiper-container-wrapper--timeline .swiper-pagination-progressbar {
  position: relative;
  margin-bottom: 70px;
  background-color: transparent;
  height: 4px;
  border-bottom: 1px solid #888;
  width: 100%;
}

.swiper-container-wrapper--timeline .swiper-pagination-progressbar-fill {
  background-color: #000;
  height: 3px;
  top: 2px;
}

.swiper-container-wrapper--timeline .swiper-pagination-progressbar:before {
  position: absolute;
  top: 2px;
  left: 0;
  width: 100%;
  height: 3px;
  background-color: #000;
  content: "";
}

.swiper-container-wrapper--timeline .swiper-pagination-progressbar:after {
  position: absolute;
  top: 2px;
  right: -100%;
  width: 100%;
  height: 3px;
  background-color: #000;
  content: "";
}

.swiper-container-wrapper--timeline .swiper-pagination-custom {
  position: relative;
  list-style: none;
  display: flex;
  line-height: 1.66;
  bottom: -16px;
  z-index: 11;
  width: 100%;
}

.swiper-container-wrapper--timeline .swiper-pagination-custom .swiper-pagination-switch {
  position: relative;
  width: 100%;
  height: 38px;
}

.swiper-container-wrapper--timeline .swiper-pagination-custom .swiper-pagination-switch .switch-title {
  position: absolute;
  font-weight: 400;
  transform: translateX(50%);
  transition: 0.2s all ease-in-out;
  transition-delay: 0s;
  cursor: pointer;
  z-index: 1;
}

.swiper-container-wrapper--timeline .swiper-pagination-custom .swiper-pagination-switch .switch-title:after {
  position: absolute;
  top: 100%;
  right: 50%;
  transform: translateX(50%) translateY(-50%);
  width: 12px;
  height: 12px;
  background: #000;
  border-radius: 2rem;
  content: "";
  transition: 0.2s all ease-in-out;
  transition-delay: 0s;
  z-index: 1;
}

.swiper-container-wrapper--timeline .swiper-pagination-custom .swiper-pagination-switch.active .switch-title {
  font-weight: 400;
  transition-delay: 0.4s;
}

.swiper-container-wrapper--timeline .swiper-pagination-custom .swiper-pagination-switch.active .switch-title:after {
  background: #000;
  width: 25px;
  height: 25px;
  transition-delay: 0.4s;
}

.swiper-container-wrapper--timeline .swiper-pagination-custom .swiper-pagination-switch.active ~ .swiper-pagination-switch .switch-title {
  color: #888;
  font-weight: 16px;
}

.swiper-container-wrapper--timeline .swiper-pagination-custom .swiper-pagination-switch.active ~ .swiper-pagination-switch .switch-title:after {
  background: #888;
}

.object-cover {
  object-fit: cover;
}

</style>